export default {
    categories: [],
    loading: false
};
